import React from 'react'

import PropTypes from 'prop-types'

import { useT } from '@galo-monitor/i18n'
import { fullScreen } from '@galo-monitor/icons'
import { colors } from '@galo-monitor/styles'
import Icon from '@galo-monitor/web-components/Icon'

import IconButton from '../IconButton'

const FullScreenIconButton = ({ iconColor, ...props }) => {
  const t = useT()
  return (
    <IconButton tooltip={ t('full screen') } { ...props }>
      <Icon icon={ fullScreen } color={ iconColor } />
    </IconButton>
  )
}

FullScreenIconButton.propTypes = {
  iconColor: PropTypes.string
}

FullScreenIconButton.defaultProps = {
  iconColor: colors.mutedText
}

export default FullScreenIconButton
